import { FC } from 'react'

import styled from 'styled-components'

import AnalysisIcon from 'src/Assets/Svg/analysis.svg?react'
import {
  GreyTextButton,
  GreyTextButtonProps,
} from 'src/Components/Buttons/GreyTextButton'

export type AddParameterButtonProps = Pick<
  GreyTextButtonProps,
  'onClick' | 'className' | 'disabled' | 'loading' | 'children' | 'id'
>

const StyledIcon = styled(AnalysisIcon)`
  flex-shrink: 0;
  width: 16px;
  height: 16px;
`

export const AddParameterButton: FC<AddParameterButtonProps> = ({
  children,
  ...rest
}) => (
  <GreyTextButton icon={<StyledIcon />} {...rest}>
    {children}
  </GreyTextButton>
)
